var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"blue-toolbar row",staticStyle:{"margin-top":"0px","padding":"1.05rem","margin-left":"0px"}})])
}]

export { render, staticRenderFns }